// ENV
export const IS_LOCAL = process.env.NODE_ENV === 'none';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

// LS
export const POP_CURRENT_TEAM = 'POP_CURRENT_TEAM';

// Tariff management

export const PAY_STATUSES = {
  succeeded: 'succeeded', // зачислен на баланс (/store/pay)
  pending: 'pending', // ожидает действия от стороннего сервиса (/store/pay)
  processing: 'processing', // еще не завершился (/store/pay)
  unpaid: 'unpaid', // создан, но не оплачен (/store/checkStatus)
  paid: 'paid', // оплачен (/store/checkStatus)
  error: 'error', // ошибка (/store/checkStatus)
  requires_payment_method: 'requires_payment_method', // запрос платежного метода (для 3D-secure)
};

export const PAY_STATUSES_MODAL = {
  SUCCESS: 'SUCCESS',
  PENDING: 'PENDING',
  ERROR: 'ERROR',
};

export const PAY_STATUSES_MODAL_ALIAS = {
  succeeded: PAY_STATUSES_MODAL.SUCCESS,
  pending: PAY_STATUSES_MODAL.PENDING,
  processing: PAY_STATUSES_MODAL.PENDING,
  unpaid: PAY_STATUSES_MODAL.PENDING,
  paid: PAY_STATUSES_MODAL.SUCCESS,
  error: PAY_STATUSES_MODAL.ERROR,
};

export const SCREEN = {
  content: 'content',
  yookassa: 'yookassa',
  stripe: 'stripe',
};

// PayMethods
export const PAY_METHODS = {
  CARD: 'card',
  SEPA_DEBIT: 'sepa_debit',
  ALIPAY: 'alipay',
  BANCONTACT: 'bancontact',
  EPS: 'eps',
  GIROPAY: 'giropay',
  IDEAL: 'ideal',
  P24: 'p24',
  SOFORT: 'sofort',
};

// Countries
export const COUNTRIES_CODE = {
  AT: 'AT',
  BE: 'BE',
  BG: 'BG',
  CY: 'CY',
  CZ: 'CZ',
  DE: 'DE',
  DK: 'DK',
  EE: 'EE',
  GR: 'GR',
  ES: 'ES',
  FI: 'FI',
  FR: 'FR',
  HR: 'HR',
  HU: 'HU',
  IE: 'IE',
  IT: 'IT',
  LT: 'LT',
  LU: 'LU',
  LV: 'LV',
  MT: 'MT',
  NL: 'NL',
  PL: 'PL',
  PT: 'PT',
  RO: 'RO',
  SE: 'SE',
  SI: 'SI',
  SK: 'SK',
};

// Currency
export const CURRENCY = {
  RUB: 'RUB',
  EUR: 'EUR',
  USD: 'USD',
};

export const TARIFF_ALIAS = {
  START: 'start',
  PRO: 'pro',
  PROPLUS: 'proplus',
  BUSINESSVR: 'businessvr',
};

export const LANG_CAPTION = {
  ru: 'Ру',
  en: 'En',
  de: 'De',
};
